<template>
  <div>
    <SettingsCard
      :title="$t('settings.account-settings.title')"
      :subtitle="$t('settings.account-settings.subtitle')"
      icon="mdi-account-cog"
      :model-value="isOpen"
      @update:modelValue="setOpen"
    >
      <div class="pa-4">
        <!-- PACKAGE -->
        <v-row>
          <v-col
            cols="12"
            sm="6"
            class="px-0 px-md-2"
          >
            <div>
              <span class="font-weight-bold">
                {{ $t('settings.account-settings.body-texts.0') }}<br />
              </span>
              <span class="text-grey">
                {{ $t('settings.account-settings.body-texts.1', { readablePlatformName }) }}
              </span>
            </div>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            class="px-0 px-md-2"
          >
            <Package
              :company="company"
              :disabled="!!pendingDowngrade?.downgradeAt"
              @downgrade="refetchPendingDowngrade"
            />
            <DowngradeInfo
              :pending-downgrade="pendingDowngrade"
              :product-type="company.productType"
              @refetch="refetchPendingDowngrade"
            />
          </v-col>
        </v-row>
      </div>
    </SettingsCard>
  </div>
</template>

<script>
import SettingsCard from '@/components/SettingsCard.vue'
import { useQueryOpen } from '@/composables/useQueryOpen'
import billwerkPortalMixin from '@/mixins/billwerkPortal'
import brandingMixing from '@/mixins/branding'

import DowngradeInfo from './DowngradeInfo.vue'
import Package from './Package.vue'
import GET_PENDING_DOWNGRADE from './queries/GetPendingDowngrade.gql'

export default {
  setup() {
    const { isOpen, setOpen } = useQueryOpen({ settingName: 'account', defaultValue: true })
    return {
      isOpen,
      setOpen,
    }
  },
  components: {
    SettingsCard,
    Package,
    DowngradeInfo,
  },
  mixins: [brandingMixing, billwerkPortalMixin],
  props: {
    company: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    refetchPendingDowngrade() {
      this.$apollo.queries.pendingDowngrade.refetch()
    },
  },
  apollo: {
    pendingDowngrade: {
      query: GET_PENDING_DOWNGRADE,
      variables() {
        return {
          companyId: this.$auth.user.companyId,
        }
      },
    },
  },
}
</script>
